
export default {
    name: 'BannerLoader',
}
